import { render, staticRenderFns } from "./BannerSliced.vue?vue&type=template&id=28d0a7de&scoped=true&"
import script from "./BannerSliced.vue?vue&type=script&lang=js&"
export * from "./BannerSliced.vue?vue&type=script&lang=js&"
import style0 from "./BannerSliced.vue?vue&type=style&index=0&id=28d0a7de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0a7de",
  null
  
)

export default component.exports